/* eslint-env browser, es6 */
/* globals XLSX CSVToArray $ */
// Refactor the below later.
/* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */

// eslint-disable-next-line no-unused-vars
function init(isXlsx, dataFile) {
			$(document).ready(function() {
    setTimeout(() => {if ($('.box1text').find('iframe').length > 0) {
        $('.box1text').css('font-size', '1.5rem');

       $(window).resize();
    }/* else {
        $('.box1text').css('font-size', '40px');
    }*/
    },100);
});
  function findFirstText(text) {
    let output = '';
    let inTag = false;
    for (let i = 0; i < text.length; i++) {
      if (!inTag && text[i] === '<') {
        inTag = true;
        if (output !== '') break;
      } else if (inTag && text[i] === '>') inTag = false;
      else if (!inTag) output += text[i];
    }
    return output;
  }

  function findFirstTextIndex(text) {
    let inTag = false;
    for (let i = 0; i < text.length; i++) {
      if (!inTag && text[i] === '<') {
        inTag = true;
      } else if (inTag && text[i] === '>') inTag = false;
      else if (!inTag) return i;
    }
    return -1;
  }

  function fixIfTooTall() {
    if ($('.box2text').height() > $('.back').height()) {
      $('.box2').textfill({
        fail: () => { $('.box2text').css('font-size', '1.5rem'); },
      });
    }
    if ($('.box1text').height() > $('.front').height()) {
      $('.box1').textfill({
        fail: () => { $('.box1').find('.text-body').css('font-size', '1.5rem'); },
      });
    }
  }

  setInterval(fixIfTooTall, 100);

  const req = new XMLHttpRequest();
  req.open('GET', dataFile, true);
  req.responseType = 'arraybuffer';
  // eslint-disable-next-line no-unused-vars
  req.onload = function onLoadFunction(onLoadEvent) {
    let CSVArray;
    if (isXlsx) {
      const alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      const wb = XLSX.read(new Uint8Array(req.response), { type: 'array' });
      const sheet = wb.Sheets[wb.SheetNames[0]];
      CSVArray = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      CSVArray.forEach((row, rowIndex) => {
        row.forEach((item, colIndex) => {
          if (colIndex < 26) {
            const html = sheet[alpha[colIndex] + (rowIndex + 1)].h;
            if (html.indexOf('&lt;/') === -1 && html.indexOf('&gt;') === -1) {
              // this is generated html but with no font name or colors in the spans,
              // but these vals are in the rich text xml output
              const spanText = '<span style="';
              if (html.indexOf(spanText) !== -1) {
                const colText = '<color rgb="';
                const fontText = '<rFont val="';
                const endSpan = '</span>';
                let ht = html;
                let htStartIndex = 0;
                let rtStartIndex = 0;
                let section = findFirstText(ht);
                const rt = sheet[alpha[colIndex] + (rowIndex + 1)].r;
                while (section.length > 0) {
                  const htEndIdx = findFirstTextIndex(ht.substring(htStartIndex, ht.length))
                      + section.length + htStartIndex;
                  const rtEndIdx = findFirstTextIndex(rt.substring(rtStartIndex, rt.length))
                      + section.length + rtStartIndex;
                  if (htEndIdx !== -1 && rtEndIdx !== -1) {
                    let htSpanIndex = ht.substring(htStartIndex, htEndIdx).indexOf(spanText);
                    if (htSpanIndex !== -1) {
                      htSpanIndex += htStartIndex;
                      let rtColorIndex = rt.substring(rtStartIndex, rtEndIdx).indexOf(colText);
                      if (rtColorIndex !== -1) {
                        rtColorIndex += rtStartIndex;
                        const color = rt.substr(rtColorIndex + colText.length + 2, 6);
                        ht = `${ht.substring(0, htStartIndex)}${ht.substring(htStartIndex, htSpanIndex)}`
                            + `${spanText}color:#${color};${ht.substring(htSpanIndex + spanText.length, ht.length)}`;
                      }
                      let rtFontIndex = rt.substring(rtStartIndex, rtEndIdx).indexOf(fontText);
                      if (rtFontIndex !== -1) {
                        rtFontIndex += rtStartIndex;
                        const font = rt.substr(rtFontIndex + fontText.length, rt.substring(rtFontIndex + fontText.length, rt.length).indexOf('"'));
                        ht = `${ht.substring(0, htStartIndex)}${ht.substring(htStartIndex, htSpanIndex)}`
                            + `${spanText}font-family:${font};${ht.substring(htSpanIndex + spanText.length, ht.length)}`;
                      }
                    }
                    let endSpanIdx = ht.substring(htStartIndex, ht.length).indexOf(endSpan);
                    if (endSpanIdx !== -1) {
                      endSpanIdx += htStartIndex + endSpan.length;
                      section = findFirstText(ht.substring(endSpanIdx, ht.length));
                      htStartIndex = endSpanIdx;
                      rtStartIndex = rtEndIdx;
                    } else break;
                  } else break;
                }
                // remove all spans for now.
                ht = ht.replace(/<\/?span[^>]*>/gi, '');
                // remove '~' from cells modified by formatting macros
                if (ht[0] === '~' && ht[ht.length - 1] === '~') {
                  ht = ht.replace(/~/g, '');
                }
                CSVArray[rowIndex][colIndex] = ht;
              } else {
                CSVArray[rowIndex][colIndex] = html;
              }
            }
          }
        });
      });
    } else {
      const enc = new TextDecoder();
      const arr = new Uint8Array(req.response);
      CSVArray = CSVToArray(enc.decode(arr), '');
    }
    // Define arrays used below
    let frontDisplay = [];
    let backDisplay = [];
    const media = [];
    const termAudio = [];
    const images = [];
    CSVArray.forEach((row) => {
      frontDisplay.push(row[0]);
      backDisplay.push(row[1]);
      termAudio.push(row[2]);
      images.push(row[3]);
    });

    // global vars
    let currentQuestion = 0;
    let currentQuestionDisplay;
    let modeToggled = 0;
    // let orginalFrontDisplay = frontDisplay;  // Unused?
    // let orginalBackDisplay = backDisplay;    // Unused?
    // load card content and resize
    function loadTextAndImages(widowResizing) {
      $('.flashcardGallery').hide();
      setTimeout(() => {if ($('.box1text').find('iframe').length > 0) {
              $('.box1text').css('font-size', '1.5rem');
               $(window).resize();
          }
          }, 100);
      if (!widowResizing) {
        $('.box1text').html(frontDisplay[currentQuestion]);
        $('.box2text').html(backDisplay[currentQuestion]);
        $('.box1text').addClass('hide-text');
        $('.box2text').addClass('hide-text');
        $('.box1text')
          .find('iframe')
          .prependTo('.box1text')
          .addClass('hide-image');
        $('.box2text')
          .find('iframe')
          .prependTo('.box2text')
          .addClass('hide-image');
        $('.box1text')
          .find('video')
          .prependTo('.box1text')
          .addClass('hide-image');
        $('.box2text')
          .find('video')
          .prependTo('.box2text')
          .addClass('hide-image');
      }
      if ($('.box1text').find('audio').length > 0) {
        $('.box1text')
          .find('audio')
          .css('width', $('.box1').width())
          .addClass('noflip');
      }
      if ($('.box2text').find('audio').length > 0) {
        $('.box2text')
          .find('audio')
          .css('width', $('.box2').width())
          .addClass('noflip');
      }
      if (
        $('.box1').width()
          - $('.box1text')
            .find('img')
            .width()
          > 80
          && $('.box1text')
            .find('img')
            .height()
          < $('.box1text')
            .find('img')
            .width()
      ) {
        $('.box1text')
          .find('img')
          .addClass('hide-image d-block p-2');
      } else {
        $('.box1text')
          .find('img')
          .addClass('hide-image float-start p-2');
      }
      $('.box1text')
        .find('img')
        .prependTo('.box1text');
      if (
        $('.box2').width()
          - $('.box2text')
            .find('img')
            .width()
          > 80
          && $('.box2text')
            .find('img')
            .height()
          < $('.box2text')
            .find('img')
            .width()
      ) {
        $('.box2text')
          .find('img')
          .addClass('hide-image d-block p-2');
      } else {
        $('.box2text')
          .find('img')
          .addClass('hide-image float-start p-2');
      }
      $('.box2text')
        .find('img')
        .prependTo('.box2text');
      setTimeout(() => {
        if ($('.box1text').find('iframe').length > 0) {
          $('.hide-text').removeClass('hide-text');
          $('.box1 > .text-body').css('font-size', '20px');
          $('.box1text')
            .find('iframe')
            .css('height', $('.box1').height() - $('.box1text').height());
          $('.box1text')
            .find('iframe')
            .css('width', $('.box1').width());
          $('.box1')
            .find('.hide-image')
            .removeClass('hide-image');
        } else if ($('.box1text').find('video').length > 0) {
          $('.hide-text').removeClass('hide-text');
          $('.box1 > .text-body').css('font-size', '20px');
          $('.box1text')
            .find('video')
            .css('height', $('.box1').height() - $('.box1text').height());
          $('.box1text')
            .find('video')
            .css('width', $('.box1').width());
          $('.box1')
            .find('.hide-image')
            .removeClass('hide-image');
        } else {
          $('.box1')
            .find('.hide-text')
            .removeClass('hide-text');
          $('.box1')
            .find('.hide-image')
            .removeClass('hide-image');
          // The resizing gets confused if we have both audio and image, this should catch that.
          if ($('.box1').find('iframe').length > 0 || ($('.box1').find('audio').length > 0 && $('.box1').find('img').length > 0)) {
            $('.box1text')
              .find('img')
              .css({
                'max-height': $('.box1').height() - $('.box1text').find('audio').height(),
                'max-width': '50%',
              });
            $('.box1text')
              .find('img')
              .removeClass('d-block')
              .addClass('float-start');
            // don't use the text fill when doing this.
            $('.box1').find('.text-body').css('font-size', '1.5rem');
          } else {
            $('.box1').textfill({
              fail: () => { $('.box1').find('.text-body').css('font-size', '40px'); },
            });
          }
        }
        if ($('.box2text').find('iframe').length > 0) {
          $('.hide-text').removeClass('hide-text');
          $('.box2text').css('font-size', '20px');
          $('.box2text')
            .find('iframe')
            .css('height', $('.box2').height() - $('.box2text').height());
          $('.box2text')
            .find('iframe')
            .css('width', $('.box2').width());
          $('.box2')
            .find('.hide-image')
            .removeClass('hide-image');
        } else if ($('.box2text').find('video').length > 0) {
          $('.hide-text').removeClass('hide-text');
          $('.box2text').css('font-size', '20px');
          $('.box2text')
            .find('video')
            .css('height', $('.box2').height() - $('.box2text').height());
          $('.box2text')
            .find('video')
            .css('width', $('.box2').width());
          $('.box2')
            .find('.hide-image')
            .removeClass('hide-image');
        } else {
          $('.box2')
            .find('.hide-text')
            .removeClass('hide-text');
          $('.box2')
            .find('.hide-image')
            .removeClass('hide-image');
          // The resizing gets confused if we have both audio and image, this should catch that.
          if ($('.box2').find('iframe').length > 0 || ($('.box2').find('audio').length > 0 && $('.box2').find('img').length > 0)) {
            $('.box2text')
              .find('img')
              .css({
                'max-height': $('.box2').height() - $('.box2text').find('audio').height(),
                'max-width': '50%',
              });
            $('.box2text')
              .find('img')
              .removeClass('d-block')
              .addClass('float-start');
            $('.box2text').css('font-size', '1.5rem');
          } else {
            $('.box2').textfill({
              fail: () => { $('.box2text').css('font-size', '1.5rem'); },
            });
          }
        }
      }, 50);

      if ($('.front').find('[data-gallery="true"]').length > 0) {
        $('.front').find('.flashcardGallery').show();
      }
      if ($('.back').find('[data-gallery="true"]').length > 0) {
        $('.back').find('.flashcardGallery').show();
      }

      currentQuestionDisplay = currentQuestion + 1;
      $('#cardCount').html(`${currentQuestionDisplay} of ${frontDisplay.length}  Card(s)`);
    }
    function untoggleCard() {
      if (modeToggled === 1) {
        const prevFront = frontDisplay;
        const prevBack = backDisplay;
        frontDisplay = prevBack;
        backDisplay = prevFront;
        modeToggled = 0;
      }
    }
    function toggleTooltip() {
      if ($('.mobile-only').css('display') === 'none') {
        $('#q_buttons a').each(function() {
          $(this).tooltip('disable');
        });
      } else {
        $('#q_buttons a').each(function() {
          $(this).tooltip('enable');
        });
      }
    }
    loadTextAndImages();
    setTimeout(toggleTooltip, 300);
   
    
    $(window).resize(() => {
      loadTextAndImages(true);
      setTimeout(toggleTooltip, 300);
    });

    // function to view next card
    function nextCard() {
      if (currentQuestion !== frontDisplay.length - 1) {
        currentQuestion += 1;
      } else {
        currentQuestion = 0;
      }
      untoggleCard();
      if (!$('.flipper').hasClass('fliphorizontal')) {
        $('.box1').addClass('slideLeft');
        setTimeout(() => {
          $('.box1').removeClass('slideLeft');
          loadTextAndImages();
        }, 350);
      } else {
        $('.flipper').removeClass('fliphorizontal');
        setTimeout(() => {
          $('.box1').addClass('slideLeft');
          setTimeout(() => {
            $('.box1').removeClass('slideLeft');
            loadTextAndImages();
          }, 350);
        }, 200);
      }
    }
    // function to view prev card
    function prevCard() {
      if (currentQuestion !== 0) {
        currentQuestion -= 1;
      } else {
        currentQuestion = frontDisplay.length - 1;
      }
      untoggleCard();
      if (!$('.flipper').hasClass('fliphorizontal')) {
        $('.box1').addClass('slideRight');
        setTimeout(() => {
          $('.box1').removeClass('slideRight');
          loadTextAndImages();
        }, 350);
      } else {
        $('.flipper').removeClass('fliphorizontal');
        setTimeout(() => {
          $('.box1').addClass('slideRight');
          setTimeout(() => {
            $('.box1').removeClass('slideRight');
            loadTextAndImages();
          }, 350);
        }, 200);
      }
    }
    // function to toggle cards front and back
    function toggleCard() {
      $('.flipper').addClass('zoombounce');
      setTimeout(() => {
        $('.flipper').removeClass('zoombounce');
        if (modeToggled === 1) {
          $('#toggle_card i')
            .first()
            .removeClass('fa-toggle-off')
            .addClass('fa-toggle-on');
          modeToggled = 0;
        } else {
          $('#toggle_card i')
            .first()
            .removeClass('fa-toggle-on')
            .addClass('fa-toggle-off');
          modeToggled = 1;
        }
      }, 200);
      
      const temp1 = frontDisplay;
      const temp2 = backDisplay;
      frontDisplay = temp2;
      backDisplay = temp1;
      loadTextAndImages();
      const cardSide = $('#card-side').html();
      cardSide === 'Front of card' ? $('#card-side').html('Back of card') : $('#card-side').html('Front of card');
    }
    // function to shuffle cards
    function shuffleCards() {
      for (let i = frontDisplay.length - 1; i > 0; i--) {
        const randomNumber = Math.floor((i + 1) * Math.random());
         if (i === randomNumber) {
            randomNumber = Math.floor((i) * Math.random());
        }
        const newFrontDisplay = frontDisplay[i];
        const newBackDisplay = backDisplay[i];
        const newImages = images[i];
        const newMedia = media[i];
        const newAudio = termAudio[i];
        frontDisplay[i] = frontDisplay[randomNumber];
        backDisplay[i] = backDisplay[randomNumber];
        images[i] = images[randomNumber];
        media[i] = media[randomNumber];
        termAudio[i] = termAudio[randomNumber];
        frontDisplay[randomNumber] = newFrontDisplay;
        backDisplay[randomNumber] = newBackDisplay;
        images[randomNumber] = newImages;
        media[randomNumber] = newMedia;
        termAudio[randomNumber] = newAudio;
      }
      untoggleCard();
      if (!$('.flipper').hasClass('fliphorizontal')) {
        $('.flipper').addClass('shaker');
        setTimeout(() => {
          $('.flipper').removeClass('shaker');
        }, 200);
        $('.flipper').removeClass('fliphorizontal');
        loadTextAndImages();
      } else {
        $('.flipper').removeClass('fliphorizontal');
        setTimeout(() => {
          $('.flipper').addClass('shaker');
          setTimeout(() => {
            $('.flipper').removeClass('shaker');
          }, 250);
          $('.flipper').removeClass('fliphorizontal');
          loadTextAndImages();
        }, 200);
      }
    }
    // function to remove a card
    function removeCard() {
      if (frontDisplay.length === 1) {
        alert('This is the last Flashcard, you cannot remove anymore!');
      } else {
        untoggleCard();
        $('.flipper').addClass('fadeout');
        setTimeout(() => {
          $('.flipper').removeClass('fadeout');
          frontDisplay.splice(currentQuestion, 1);
          backDisplay.splice(currentQuestion, 1);
          currentQuestion = 0;
          loadTextAndImages();
        }, 200);
      }
    }
    // function to restore cards
    function restoreCards() {
      window.location.reload(); // fix for now
    }

    // EVENTS
    // toggle template
    
    // flip card button
    // $('#flip_card').click(() => {
    //   fixIfTooTall();
    //   if ($('.flipper').hasClass('fliphorizontal')) {
    //     $('.flipper').removeClass('fliphorizontal');
    //   } else {
    //     $('.flipper').addClass('fliphorizontal');  
    //   }
    // });

    // next question button
    $('#button_next').click((e) => {
      e.preventDefault();
      nextCard();
    });
    // previous question button
    $('#button_prev').click((e) => {
      e.preventDefault();
      prevCard();
    });
    // toggle front and back display button
    $('#toggle_card').click((e) => {
      e.preventDefault();
      toggleCard();
    });
    // shuffle button
    $('#button_shuffle').click((e) => {
      e.preventDefault();
      shuffleCards();
    });
    // remove card from array button
    $('#button_remove').click((e) => {
      e.preventDefault();
      removeCard();
    });
    // restore array button
    $('#button_restore').click((e) => {
      e.preventDefault();
      restoreCards();
    });

    //when the user clicks or taps, the card flips
    $('.flipper').swipe({
      tap: function tapFunction(e) {

        if ($(e.target).hasClass('noflip')) { return; }
        toggleCard();
      },
    });

    // when user double taps, the deck shuffles
    $('.flipper').swipe({
      doubleTap: shuffleCards,
    });

    // when the user swipes left, next card is displayed
    $('.flipper').swipe({
      swipeLeft: nextCard,
    });
    // when the user swipes right, prev card is displayed
    $('.flipper').swipe({
      swipeRight: prevCard,
    });

    // prevents user from scolling when using flashcards
    $('.flipper').bind('touchmove', (e) => {
      e.preventDefault();
    });

    $('#access').on('touchstart click', () => {
      $('#accessibleModal').modal('show');
    });

    $('#accessibleModal').on('shown.bs.modal', () => {
      $('.content').attr('aria-hidden', 'true');
    });

    $('#accessibleModal').on('hide.bs.modal', () => {
      $('.content').attr('aria-hidden', 'false');
    });

    $('#accessibleModal').on('hidden.bs.modal', () => {
      $('#access').focus();
    });

    $('#accessibleModal').on('shown.bs.modal', () => {
      $('#closeModal').focus();
    });

    $('.flashcardGallery').click((event) => {
      event.stopImmediatePropagation();
      const objects = [];
      const target = $('.flipper').hasClass('fliphorizontal') ? '.back' : '.front';

      $(target).find('[data-gallery="true"]').each((index, myself) => {
        const thisObject = {};
        const $thisThing = $(myself);
        if ($thisThing.prop('tagName') === 'VIDEO') {
          $thisThing.get(0).pause();
          const clone = $thisThing.clone();
          clone.prop('style', '');
          // TODO - keep time when popping open?
          thisObject.src = clone.prop('outerHTML');
          thisObject.type = 'html';
        } else if ($thisThing.prop('tagName') === 'IMG') {
          thisObject.src = $thisThing.attr('src');
          if ($thisThing.attr('data-caption')) {
            thisObject.caption = $thisThing.attr('data-caption');
          }
        } else {
          console.warn(`Element ${index} cannot be added to a gallery`);
          return;
        }

        objects.push(thisObject);
      });

      if (objects.length > 0) {
        $.fancybox.open(objects);
      }
    });
  };
  req.send();
}
